// extracted by mini-css-extract-plugin
export default {"dialogContent":"SendToGroupOfUsers_dialogContent__KtZN0"};